module.exports = __webpack_public_path__ + "static/img/zhuan2.bb2e237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/zhuan2.png
// module id = h1p7
// module chunks = 1